module.exports = __webpack_public_path__ + "fonts/Montserrat-200-latin-ext4.9f73369.woff2";